// extracted by mini-css-extract-plugin
export default {"Following":"Following_Following__G+jy-"};